import { ColumnDef } from "@tanstack/react-table";
import { format } from "date-fns";

import { Activity } from "./schema";
import { DataTableColumnHeader } from "./data-table-column-header";

import { Badge } from "@/components/ui/badge/badge";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover/popover";

// import { DataTableRowActions } from "./data-table-row-actions";

export const columns: ColumnDef<Activity, any>[] = [
  {
    accessorKey: "date",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Date" />
    ),
    cell: ({ row }) => (
      <div className="w-[180px] flex flex-col">
        <span className="text-xs">{row.getValue("date")}</span>
      </div>
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Employee" />
    ),
    cell: ({ row }) => (
      <div className="flex flex-col gap-1">
        <span>{row.getValue("employeeName")}</span>
        <span className="text-xs">{row.getValue("name")}</span>
      </div>
    ),
    enableSorting: false,
  },

  {
    accessorKey: "loginTime",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Login Time" />
    ),
    cell: ({ row }) => {
      const originData = row.original as Activity & {
        loginInfo: {
          ip: string;
          device: string;
          os: string;
          screenSize: string;
          browser: string;
        };
      };
      return (
        <div className="flex flex-col gap-2 items-start">
          {(row.getValue("loginTime") as string) &&
            format(new Date(row.getValue("loginTime")), "p")}

          <Popover>
            <PopoverTrigger>
              <span className="hover:underline">( Info )</span>
            </PopoverTrigger>
            <PopoverContent>
              <div className="flex flex-col gap-1">
                <div className="flex items-center gap-2">
                  <span>IP : </span>
                  <Badge>{originData?.loginInfo?.ip}</Badge>
                </div>
                <div className="flex items-center gap-2">
                  <span>Device : </span>
                  <Badge>{originData?.loginInfo?.device}</Badge>
                </div>
                <div className="flex items-center gap-2">
                  <span>OS : </span>
                  <Badge>{originData?.loginInfo?.os}</Badge>
                </div>
                <div className="flex items-center gap-2">
                  <span>Screen Size : </span>
                  <Badge>{originData?.loginInfo?.screenSize}</Badge>
                </div>
                <div className="flex items-center gap-2">
                  <span>Browser : </span>
                  <Badge>{originData?.loginInfo?.browser}</Badge>
                </div>
              </div>
            </PopoverContent>
          </Popover>
        </div>
      );
    },
    enableColumnFilter: false,
    enableSorting: false,
  },

  {
    accessorKey: "logoutTime",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Logout Time" />
    ),
    cell: ({ row }) => {
      const originData = row.original as Activity & {
        logoutInfo:
          | {
              ip: string;
              device: string;
              os: string;
              screenSize: string;
              browser: string;
            }
          | undefined;
      };
      return (
        <div className="flex flex-col gap-2 items-start">
          {(row.getValue("logoutTime") as string) &&
            format(new Date(row.getValue("logoutTime")), "p")}

          {originData?.logoutInfo && (
            <Popover>
              <PopoverTrigger>
                <span className="hover:underline">( Info )</span>
              </PopoverTrigger>
              <PopoverContent>
                <div className="flex flex-col gap-1">
                  <div className="flex items-center gap-2">
                    <span>IP : </span>
                    <Badge>{originData?.logoutInfo?.ip}</Badge>
                  </div>
                  <div className="flex items-center gap-2">
                    <span>Device : </span>
                    <Badge>{originData?.logoutInfo?.device}</Badge>
                  </div>
                  <div className="flex items-center gap-2">
                    <span>OS : </span>
                    <Badge>{originData?.logoutInfo?.os}</Badge>
                  </div>
                  <div className="flex items-center gap-2">
                    <span>Screen Size : </span>
                    <Badge>{originData?.logoutInfo?.screenSize}</Badge>
                  </div>
                  <div className="flex items-center gap-2">
                    <span>Browser : </span>
                    <Badge>{originData?.logoutInfo?.browser}</Badge>
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          )}
        </div>
      );
    },
    enableColumnFilter: false,
    enableSorting: false,
  },

  {
    accessorKey: "totalWorkedHours",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Total Worked Hours" />
    ),
    cell: ({ row }) => (
      <div>
        <Badge variant="outline">{row.getValue("totalWorkedHours")}</Badge>
      </div>
    ),
    enableColumnFilter: false,
    enableSorting: false,
  },

  // {
  //   id: "actions",
  //   cell: ({ row }) => <DataTableRowActions row={row} />,
  // },
];
